module.exports = __webpack_public_path__ + "img/zoom-icon.3aea3715.svg";